<template>
    <div class="relative flex">
        <UButton
            variant="ghost"
            color="gray"
            icon="i-solar-magnifer-line-duotone"
            @click="openModal"
            aria-label="search"
        />
        <UModal v-model="isModalOpen" @close="closeModal" :ui="{ width: 'w-full sm:max-w-xl' }">
            <LazyUtilsSearchModal />
        </UModal>
    </div>
</template>

<script lang="ts" setup>
const isModalOpen = ref(false);

function openModal() {
    isModalOpen.value = true;
    history.pushState({ modal: true }, "Modal Open");
}

function closeModal() {
    isModalOpen.value = false;
    if (history.state?.modal) {
        history.back();
    }
}

function handlePopState(event: PopStateEvent) {
    if (isModalOpen.value) {
        closeModal();
    }
}

onMounted(() => {
    window.addEventListener("popstate", handlePopState);
});

onUnmounted(() => {
    window.removeEventListener("popstate", handlePopState);
});
</script>

<style scoped></style>
